<div class="mobi-ui-grid is-centered">
  <div class="mobi-ui-col-1/1 xl:mobi-ui-col-3/4">
    <div class="mobi-ui-card-silent mobi-ui-relative is-size-lg mt-10 lg:mt-12">
      @if (title) {
        <h3 class="!mb-1 mobi-ui-margin-t-xs">{{ title }}</h3>
      }
      @if (text) {
        <mobi-text [data]="text" />
      }
      <div class="mobi-ui-slot-major is-top-left-inner">
        <mobi-ui-illustration-major
          [forceMobi]="true"
          class="w-[150px] lg:w-[180px] [&_*]:!p-0 !p-0"
          [illustration]="{ name: illustration }"
        />
      </div>
    </div>
  </div>
</div>
